export default __webpack_public_path__ + "static/screenshot-feature-importances--mobile-b7418f2a3a38c6ddde497e868da6eda4.png";